// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","title":"Card_title__fjt9r","cardHeader":"Card_cardHeader__8A8CE"};